import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
});

const EditSessionButtonComponent = ({
  sessionId,
  fileId,
  history,
  classes,
  disabled
}) => (
  <Button onClick={() => history.push(`/project/${sessionId}/file/${fileId}`)} color="primary" disabled={disabled}>
    <Icon className={classes.icon}>edit</Icon>
    edit
  </Button>
);

EditSessionButtonComponent.propTypes = {
  sessionId: PropTypes.string.isRequired,
  fileId: PropTypes.string.isRequired,
  /* eslint-disable react/forbid-prop-types */
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
  disabled: PropTypes.bool
};

export default withStyles(styles)(withRouter(EditSessionButtonComponent));
